var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
/**
 * Read shape for a generated DATEV export. Returned on the post-generation
 * round-trip and listed in the export history (slice #9). The CSV bytes
 * themselves are streamed via a separate download endpoint — this DTO
 * carries metadata only.
 */
export class DatevExportResponseDto {
    id;
    officeLocationId;
    /** `"YYYY-MM"` — the calendar month this export covers. */
    yearMonth;
    /** Per-(officeLocation, yearMonth) sequence number; starts at 1. */
    sequenceNumber;
    /** `EXTF_Buchungsstapel_YYYYMMDD_NNN.csv`. */
    filename;
    /** Number of `(invoice, taxSubtotal)` rows written. */
    rowCount;
    snapshotAt;
    /**
     * Byte size of the archived CSV (slice #9). Surfaced in the history-list
     * UI so the user can spot a partial-write at a glance. `null` while
     * the run is IN_PROGRESS / FAILED (no archived bytes exist for those
     * states; the history endpoint only returns COMPLETED rows so in
     * practice this is non-null in the list).
     */
    archiveSizeBytes;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], DatevExportResponseDto.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], DatevExportResponseDto.prototype, "officeLocationId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], DatevExportResponseDto.prototype, "yearMonth", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], DatevExportResponseDto.prototype, "sequenceNumber", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], DatevExportResponseDto.prototype, "filename", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], DatevExportResponseDto.prototype, "rowCount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], DatevExportResponseDto.prototype, "snapshotAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DatevExportResponseDto.prototype, "archiveSizeBytes", void 0);
//# sourceMappingURL=datev-export.response.dto.js.map